import React, { Component } from 'react';

// Highcharts
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'

// Material helpers
import highchartsMore from "highcharts/highcharts-more.js";
import solidGauge from "highcharts/modules/solid-gauge.js";

import { withRouter } from 'react-router-dom';

// Shared components
import PortletContent from 'components/PortletContent';


// Material components
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import PerfectScrollbar from 'react-perfect-scrollbar';

// Palette

// Component styles
//import styles from './styles';
import { api_host, api_auth } from '../../../../../common/globals/constants';
import moment from 'moment'
import 'moment/locale/es'  
import { useTranslation } from 'react-i18next';
import { reportFetchError } from '../../../../../observability/rum';
moment.locale('es')

highchartsMore(Highcharts);
solidGauge(Highcharts);


class AvailabilityGaugeChart extends Component {

    _currentObjectiveId = null;

    constructor(props) {

        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            actualUptime: 0,
            chartBaseColor: '#FFFFFF',
            externalData: null,
            dataError: false,
            isLoading: true,
            time: 'h',
            chartOptionsBase: this._chartOptionsBase,
            chartOptions: this._chartOptionsBase,
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            date: this.props.params.date,
            isRefresh: this.props.params.isRefresh,
            dateMoment:((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            real:this.props.params.real,
            isWithoutNoMon: this.props.params.isWithoutNoMon,
            isOnlyUptime: this.props.params.isOnlyUptime,
            externalData: []
        }

    }
    _chartOptionsBase = {
        chart: {
            type: 'solidgauge',
            height: 200
        },
        title: {
            text: ''
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: ''
            }
        },
        xAxis: {
            categories: ['nada'],
            labels: {
                rotation: -45,
                enabled: true
            },
            title: {
                text: null,
            },
            gridLineWidth: 0,

        },
        yAxis: {
            labels: {
                enabled: false,
                rotation: 'auto',
                style:{
                    color: '#FFF'
                }
            },
	        min: 0,
	        max: 100,  
	    },
        legend: {
            enabled: false
        },

        series: [
        ],
        credits: {
            enabled: false
        },
        plotOptions: {
            solidgauge: {
                dataLabels: {
                    y: 5,
                    borderWidth: 0,
                    useHTML: true,
                    color:'#66788A'
                }
            }
        }
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        
        if (nextProps.match.params.objetivo_id !== prevState.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                chartBaseColor: null,
                chartOptions: prevState.chartOptionsBase,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod, 
                isWithoutNoMon: prevState.isWithoutNoMon, 
                isOnlyUptime: prevState.isOnlyUptime,
                externalData: prevState.externalData
            }
        } else if (nextProps.params.period !== prevState.time) {
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod, 
                isWithoutNoMon: prevState.isWithoutNoMon, 
                isOnlyUptime: prevState.isOnlyUptime,
                externalData: prevState.externalData
            }
        } else if ((nextProps.params.period === prevState.time) && (nextProps.params.statePeriod !== prevState.statePeriod)) {
            return {
                chartOptions: prevState.chartOptionsBase,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod,
                isWithoutNoMon: prevState.isWithoutNoMon, 
                isOnlyUptime: prevState.isOnlyUptime,
                externalData: prevState.externalData
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh, 
                isWithoutNoMon: prevState.isWithoutNoMon,
                isOnlyUptime: prevState.isOnlyUptime,
                externalData: prevState.externalData          
            }

        } else if(nextProps.params.date !== prevState.date){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                date: nextProps.params.date, 
                isWithoutNoMon: prevState.isWithoutNoMon, 
                isOnlyUptime: prevState.isOnlyUptime,
                externalData: prevState.externalData         
            }

        } else if(nextProps.params.isWithoutNoMon !== prevState.isWithoutNoMon){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isWithoutNoMon: nextProps.params.isWithoutNoMon, 
                isOnlyUptime: prevState.isOnlyUptime,
                externalData: prevState.externalData        
            }

        } else if(nextProps.params.isOnlyUptime !== prevState.isOnlyUptime){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isWithoutNoMon: nextProps.params.isWithoutNoMon, 
                isOnlyUptime: nextProps.params.isOnlyUptime,
                externalData: prevState.externalData        
            }

        }
        return null;
    }

    componentDidMount() {

        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
                this.getDataFromAPI();
        }
        if (prevProps.params.isWithoutNoMon !== this.state.isWithoutNoMon || prevProps.params.isOnlyUptime !== this.state.isOnlyUptime){
            const { fromObjective } = this.props.location.state
            const { period } = this.props.params
            const { externalData, isWithoutNoMon, isOnlyUptime } = this.state
            let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
            let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
            let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
            let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
            this.processData(externalData, sla_rendimiento_ok,
                sla_rendimiento_error,
                sla_disponibilidad_ok,
                sla_disponibilidad_error,
                period, isWithoutNoMon, isOnlyUptime)
        }

    }


    getDataFromAPI = (objectiveId) => {

        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod } = this.props.params
        const { isWithoutNoMon, isOnlyUptime } = this.state

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio=""
        let fecha_termino=""
        var fetchApi="getDisponibility"
        if(period==="c"){
            fetchApi="getDisponibilityCustom"
            fecha_termino=moment(statePeriod.endDate).format("YYYY-MM-DD")
            fecha_inicio=moment(statePeriod.startDate).format("YYYY-MM-DD")
        }
        fetch(api_host + `/reporte/online/indicadores/${fetchApi}/?user=${user}&key=${api_auth}&objetivoId=${objetivo_id}&t=${period}&token=${token}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('HTTP error ' + response.status);
                }
                return response.json();
            })
            .then(myJson => {
                // Se define el state de acuerdo a la petición y respuesta de la promesa 
                if (myJson.status == 1 || myJson.status == 5) {
                    localStorage.setItem('isAuthenticated', false);
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    });
                } else {
                    //Procesa la Data Recibida
                    try {
                        this.processData(myJson, sla_rendimiento_ok,
                            sla_rendimiento_error,
                            sla_disponibilidad_ok,
                            sla_disponibilidad_error,
                            period, isWithoutNoMon, isOnlyUptime)
                        /*if (this.state.lastEvent !== []) {
                            this.props.params.onFirstInfo(this.state.lastEvent)
                        }*/
                    } catch (error) {
                        this.setState({
                            dataError: true,
                            data: null,
                            isLoading: false
                        });
                    }
                }

            })
            .catch(error => {
                reportFetchError('AvailabilityGaugeChart', error);
                this.setState({
                    dataError: true,
                    data: null,
                    isLoading: false
                });
            });

    }


    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period, isWithoutNoMon, isOnlyUptime) => {

            // Si hay datos defindos
            var uptime = externalData.data.uptime;
            if(this.state.real===true){
                uptime = parseFloat(externalData.data.uptime) + parseFloat(externalData.data.parcial) + parseFloat(externalData.data['evento_cliente'] + parseFloat(externalData.data['marcado_atentus']))
                if (!isWithoutNoMon) {
                    uptime = uptime + parseFloat(externalData.data["no monitoreo"])
                }
            } else {
                uptime = parseFloat(externalData.data.uptime) + parseFloat(externalData.data['evento_cliente'] + parseFloat(externalData.data['marcado_atentus'])) + parseFloat(externalData.data["no monitoreo"])
                if (isOnlyUptime) {
                    uptime = externalData.data.uptime;
                }
            }
            uptime=(parseFloat(uptime.toFixed(2)))
            this.setState({
                chartOptions: {
                    pane: {
                        center: ['50%', '75%'],
                        size: '130%',
                        startAngle: -90,
                        endAngle: 90,
                        background: {
                            innerRadius: '60%',
                            outerRadius: '100%',
                            shape: 'arc'
                        }
                    },
                    yAxis: [
                        {
                            labels: {
                                enabled: false,
                                rotation: 'auto',
                                style:{
                                    color: '#FFF'
                                }
                            },
                            min: 0,
                            max: 100,    
                            stops: [
                                [0, '#C2272D'], // red
                                [sla_disponibilidad_error/100, '#C2272D'], // red
                                [sla_disponibilidad_error/100+0.0001, '#FFC600'], // yellow
                                [sla_disponibilidad_ok/100-0.0001, '#FFC600'], // yellow
                                [sla_disponibilidad_ok/100, '#41B900'], // green
                                [1, '#41B900'], // green
                            ]
                        },{
                            linkedTo: 0,
                            lineWidth: 0,
                            minorTickLength: 0,
                            tickPositions: [sla_disponibilidad_error],
                            tickLength: 60,
                            tickColor: '#DF5353',
                            tickWidth: 3,                                             
                            zIndex: 6,
                        },{
                            linkedTo: 0,
                            lineWidth: 0,
                            minorTickLength: 0,
                            tickPositions: [sla_disponibilidad_ok],
                            tickLength: 60,
                            tickColor: '#55BF3B',
                            tickWidth: 3,                                                    
                            zIndex: 6,
                        }                         
                    ],
                    series: [
                        {
                            name: 'Uptime',
                            color: '#41B900',
                            data: [uptime > 100 ? 100.00 : uptime],
                            dataLabels: {
                                format:
                                    '<div style="text-align:bottom">' +
                                    '<span style="font-size:25px">{y}</span>' +
                                    '<span style="font-size:12px;opacity:0.4">%</span>' +
                                    '</div>',
                                style: {
                                    color:'#66788A'
                                }
                            },
                        },{
                            name: 'Uptime',
                            type: 'gauge',
                            data: [uptime]
                        }
                    ]
                },
                dataError: false,
                isLoading: false,
                //lastEvent: lastEventDict,
                time: period,
                externalData: externalData,
            });
            //}
    }


    render() {
        const { dataError, chartOptions, isLoading,chartOptionsBase } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        if (!dataError) {
            // this._chartOptionsBase.series = chartOptions.series
            // this._chartOptionsBase.yAxis['stops'] = chartOptions.series.yAxis[0]['stops']
            // console.log("ESTILO",Object.keys(style))
            if(Object.keys(style).length == 0){
                
                if(this.state.real===true){
                    sessionStorage.setItem("availabilityGaugeReal",JSON.stringify(chartOptionsBase))
                }else{
                    sessionStorage.setItem("availabilityGauge",JSON.stringify(chartOptionsBase))
                }
                
            }

           
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} />)
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p>Error!</p>)
    }

}

function FormattedChart(props) {
    const { t } = useTranslation()
    return (
        <div >
            <div style={props.styleHidden}>
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            {t('text.loading')}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>
            <div style={props.style}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}


export default withRouter(AvailabilityGaugeChart);